import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import styled from 'foundations-theming/utils';
import { breakpoint } from 'pricing-pages-ui-components/constants/Breakpoints';
import { trackButtonClick } from '../utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
const MobileHide = styled.div.withConfig({
  displayName: "PublicPricingPlanToggleButton__MobileHide"
})({
  [breakpoint.tablet]: {
    display: 'none'
  }
});
export const PublicPricingPlanToggleButton = ({
  isEnterpriseTier,
  onToggle
}) => {
  return /*#__PURE__*/_jsx(MobileHide, {
    children: /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      marginBlockStart: "600",
      children: /*#__PURE__*/_jsx(View, {
        textAlign: "center",
        children: /*#__PURE__*/_jsx(Button, {
          use: "link",
          onClick: () => {
            trackButtonClick({
              action: isEnterpriseTier ? 'clicked show all plans toggle' : 'clicked view enterprise plans toggle',
              value: isEnterpriseTier ? 'show_all_plans' : 'view_enterprise_plans'
            });
            onToggle();
          },
          "aria-pressed": isEnterpriseTier,
          "data-selenium-id": "pricing-plan-toggle-button",
          children: isEnterpriseTier ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "publicPricingPage.toggleButton.showAllPlans"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "publicPricingPage.toggleButton.viewEnterprisePlans"
          })
        })
      })
    })
  });
};